import axios from "./httpClient";

export function fetchSchemaDataApi(api) {
  return axios.get(`/${api}/data/schema`);
}
